export function loadMoreCatPosts(categoryId) {
  document.addEventListener("DOMContentLoaded", function () {
    function loadMoreCategoryPosts() {
      const categoryId = categoryData.categoryId; // Get the category ID from PHP
      let currentPage = 1;
      const postsPerPage = 12;
      const postContainerCat = document.getElementById("post-container-cat");
      const readMoreBtn = document.getElementById("read-more-btn-cat");
      const noPostsMessage = document.getElementById("no-posts-message-cat");
      const loadingFadeDelayMs = 250;

      let hasLoadedAllPosts = false;
      const excludedPosts = window.excludedPosts || [];

      if (!postContainerCat || !readMoreBtn) {
        return;
      }

      const defaultBtnLabel = readMoreBtn.innerHTML;

      function setLoadingState(isLoading) {
        if (isLoading) {
          readMoreBtn.classList.add("loading");
          postContainerCat.classList.add("loading");
          readMoreBtn.textContent = "Loading...";
          return;
        }

        readMoreBtn.classList.remove("loading");
        postContainerCat.classList.remove("loading");
        readMoreBtn.innerHTML = defaultBtnLabel;
      }

      function getEmbeddedImageUrl(post) {
        const media = post?._embedded?.["wp:featuredmedia"]?.[0];
        return (
          media?.media_details?.sizes?.medium_large?.source_url ||
          media?.media_details?.sizes?.medium?.source_url ||
          media?.source_url ||
          ""
        );
      }

      function getEmbeddedAuthorName(post) {
        return post?._embedded?.author?.[0]?.name || "";
      }

      function getEmbeddedCategoryName(post) {
        const terms = post?._embedded?.["wp:term"] || [];
        const categories = terms[0] || [];
        return categories[0]?.name || "";
      }

      function scrollToNewPosts(firstNewPostElement) {
        if (!firstNewPostElement) {
          return;
        }

        const fixedHeader = document.querySelector("header");
        const headerOffset = fixedHeader
          ? fixedHeader.getBoundingClientRect().height
          : 0;
        const extraOffset = 16;
        const targetY =
          window.scrollY +
          firstNewPostElement.getBoundingClientRect().top -
          headerOffset -
          extraOffset;

        window.scrollTo({
          top: Math.max(targetY, 0),
          behavior: "smooth",
        });
      }

      async function loadPostsFromCategory() {
        if (hasLoadedAllPosts) {
          return;
        }

        let firstNewPostElement = null;

        try {
          setLoadingState(true);

          const response = await fetch(
            `https://promotioncentre.co.uk/wp-json/wp/v2/posts?per_page=${postsPerPage}&page=${currentPage}&exclude=${excludedPosts.join(
              ","
            )}&categories=${categoryData.categoryId}&_embed=1`
          );

          const data = await response.json().catch(() => []);

          const noInitialResults =
            currentPage === 1 &&
            postContainerCat.children.length === 0 &&
            Array.isArray(data) &&
            data.length === 0;

          if (noInitialResults) {
            if (noPostsMessage) {
              noPostsMessage.classList.remove("hidden");
            }
            readMoreBtn.style.display = "none";
            hasLoadedAllPosts = true;
            return;
          }

          if (!response.ok) {
            throw new Error("Failed to fetch data from the API");
          }

          const total_pages = parseInt(
            response.headers.get("X-WP-TotalPages"),
            10
          );

          if (!total_pages) {
            console.error("Could not determine the total number of pages.");
            return;
          }

          if (noPostsMessage) {
            noPostsMessage.classList.add("hidden");
          }

          // Function to decode HTML entities
          function decodeEntities(encodedString) {
            const parser = new DOMParser();
            const dom = parser.parseFromString(
              "<!doctype html><body>" + encodedString,
              "text/html"
            );
            return dom.body.textContent;
          }

          await Promise.all(
            data.map(async (post) => {
            const aElement = document.createElement("a");
            aElement.classList.add(
              "relative",
              "overflow-hidden",
              "block",
              "font-light",
              "text-black",
              "no-underline",
              "article"
            );
            aElement.href = post.link;

            const categoryName = getEmbeddedCategoryName(post);
            if (categoryName) {
              const categorySpan = document.createElement("span");
              categorySpan.classList.add(
                "absolute",
                "top-0",
                "right-0",
                "z-40",
                "px-2",
                "py-1",
                "text-sm",
                "text-white",
                "rounded-tr-lg",
                "rounded-bl-lg",
                "bg-secondary"
              );
              categorySpan.textContent = categoryName;
              aElement.appendChild(categorySpan);
            }

            // Initialize elements for title and excerpt
            const h3Element = document.createElement("h3");
            h3Element.classList.add(
              "my-2",
              "text-xl",
              "lg:text-2xl",
              "leading-normal",
              "normal-case",
              "font-buenosaires"
            );

            // Decode HTML entities in the title
            const decodedTitle = decodeEntities(post.title.rendered);
            h3Element.textContent = decodedTitle;

            const excerptDiv = document.createElement("div");
            excerptDiv.classList.add("mt-2");

            if (post.excerpt && post.excerpt.rendered) {
              excerptDiv.innerHTML = post.excerpt.rendered;
            } else if (post.acf && post.acf.article_introduction) {
              excerptDiv.innerHTML = post.acf.article_introduction;
            }

            const thumbnailUrl = getEmbeddedImageUrl(post);
            if (thumbnailUrl) {
              const outerDiv = document.createElement("div");
              outerDiv.classList.add(
                "relative", "flex", "items-center", "justify-center",
                "w-full", "mb-3", "overflow-hidden", "rounded-lg", "group",
                "after:w-full", "hover:lg:after:h-full",
                "after:transition-all", "after:ease-in-out", "after:duration-500",
                "after:h-0", "after:opacity-0", "hover:lg:after:opacity-60",
                "after:pointer-events-none", "after:absolute", "after:top-0",
                "after:bg-black", "after:z-30", "after:left-0"
              );

              const readLabel = document.createElement("p");
              readLabel.classList.add(
                "absolute", "z-50", "mb-0", "text-sm", "tracking-widest",
                "text-white", "uppercase", "transition-all", "duration-500",
                "ease-in-out", "transform", "-translate-x-1/2", "-translate-y-1/2",
                "opacity-0", "top-1/2", "left-1/2",
                "group-hover:lg:delay-200", "group-hover:lg:opacity-100"
              );
              readLabel.textContent = "Read article";

              const innerDiv = document.createElement("div");
              innerDiv.classList.add(
                "relative", "flex", "z-20", "w-full", "justify-center",
                "items-center", "overflow-hidden", "img-overlay", "pb-[50%]", "group"
              );

              const imgElement = document.createElement("img");
              imgElement.src = thumbnailUrl;
              imgElement.classList.add(
                "w-full", "!transition-all", "!ease-in-out", "!duration-500",
                "mb-4", "group-hover:lg:scale-110", "transform",
                "absolute", "top-0", "h-full", "object-cover", "object-center"
              );

              innerDiv.appendChild(imgElement);
              outerDiv.appendChild(readLabel);
              outerDiv.appendChild(innerDiv);
              aElement.appendChild(outerDiv);
            }

            // Format the post date
            const postDate = new Date(post.date); // Assuming post.date is a valid date string
            const formattedDate = postDate.toLocaleDateString("en-GB", {
              day: "numeric",
              month: "short",
              year: "numeric",
            });

            // Additional HTML code (list with icons, post date, and read time)
            const ulElement = document.createElement("ul");
            ulElement.classList.add(
              "flex",
              "items-center",
              "space-x-3",
              "list-style-none"
            );

            // Create the list items with icons, post date, and read time
            const listItem1 = document.createElement("li");
            listItem1.classList.add("flex", "items-center", "text-sm");
            listItem1.innerHTML = `
           <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" class="w-5 h-6 mr-1">
             <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z" />
           </svg>
           <span>${formattedDate}</span>
         `;

            const listItem2 = document.createElement("li");
            listItem2.classList.add("flex", "items-center", "text-sm");
            listItem2.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
              stroke-width="1" stroke="currentColor" class="w-5 h-6 mr-1">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg><span>${post.read_time} min read</span>`;

            const authorName = getEmbeddedAuthorName(post);

            // Create the list item for the author
            const listItemAuthor = document.createElement("li");
            listItemAuthor.classList.add(
              "flex",
              "items-center",
              "text-sm",
              "mb-0",
              "text-sm"
            );
            listItemAuthor.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" class="mr-1 w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
      <span>By ${authorName}</span></p>
    `;

            aElement.appendChild(h3Element);
            ulElement.appendChild(listItemAuthor);
            ulElement.appendChild(listItem1);
            ulElement.appendChild(listItem2);

            aElement.appendChild(ulElement);
            aElement.appendChild(excerptDiv);
            if (postContainerCat) {
              if (!firstNewPostElement) {
                firstNewPostElement = aElement;
              }
              postContainerCat.appendChild(aElement);
            }
            })
          );

          if (currentPage >= total_pages) {
            readMoreBtn.style.display = "none";
            hasLoadedAllPosts = true;
          } else {
            currentPage++; // Only increment if there are more pages to fetch
          }
        } catch (error) {
          console.error(error);
        } finally {
          await new Promise((resolve) =>
            setTimeout(resolve, loadingFadeDelayMs)
          );
          setLoadingState(false);
          scrollToNewPosts(firstNewPostElement);
        }
      }

      loadPostsFromCategory();

      if (postContainerCat) {
        readMoreBtn.addEventListener("click", () => {
          loadPostsFromCategory();
        });
      }
    }

    if (typeof categoryData !== "undefined") {
      // Your existing code that uses categoryData
      loadMoreCategoryPosts();
    }
  });
}
